import { FC } from 'react';

import { colorsSelector } from '@redux/colorPalette/selectors';
import { languageSelector, switchInterfaceLanguage } from '@redux/language';
import analytics from 'lib/analytics';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { LOCALES, LocalesType } from 'constants/locales';
import { PATHS } from 'constants/pathsB2b';
import { sendMultiScreenEventToTv } from 'services/helpers/multiScreen';
import { PlayerEvent } from 'shared-types/player-event';

import { MenuItem, Popover } from './LanguagesPopover.style';

interface ILanguagesPopover {
  anchorEl: HTMLElement | null;
  closeMenu: () => void;
}

const LanguagesPopover: FC<ILanguagesPopover> = ({ anchorEl, closeMenu }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const colors = useSelector(colorsSelector);
  const currentLanguage = useSelector(languageSelector);

  const switchLanguage = (language: LocalesType) => {
    analytics.track('popover_language_switch', { language });
    dispatch(switchInterfaceLanguage(language));
    sendMultiScreenEventToTv(PlayerEvent.SWITCH_LANGUAGE, JSON.stringify(language));
    navigate(PATHS.HOME);
    closeMenu();
  };

  return (
    <Popover
      open={!!anchorEl}
      anchorEl={anchorEl}
      onClose={closeMenu}
      anchorOrigin={{
        vertical: 'center',
        horizontal: 'center',
      }}
      colors={colors}
    >
      {LOCALES.map((language) => (
        <MenuItem
          key={language.local}
          {...{ colors }}
          isSelected={currentLanguage === language.local}
          onClick={() => switchLanguage(language.local)}
        >
          {language.name}
        </MenuItem>
      ))}
    </Popover>
  );
};

export default LanguagesPopover;
